export const VisitConfirmMember = /* GraphQL */ `
  mutation VisitConfirmMember($input: VisitConfirmInput!) {
    visit: VisitConfirmMember(input: $input) {
      data
      success
    }
  }
`;
